import analytics from '@utils/analytics';
import api from '@utils/api';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import cookie from 'react-cookies';
import customEventBus from '@common/scripts/libs/eventBus';
import BodyMeasurements from './BodyMeasurements';
import HowToMeasure from './HowToMeasure';
import SizeGuideButton from './SizeGuideButton';
import Drawers from '@common/ui/drawes/Drawers';
const measmerizeconfig = {
    url: 'client.measmerize.com',
    brandid: window.measmerizeBrandIdWeb,
};
const scriptWrapId = 'measmerize-script-wrap';
const SizeGuide = (props) => {
    const { t } = useTranslation();
    const [sizeChart, setSizeChart] = useState();
    const [measmerizeavailable, setMeasmerizeavailable] = useState(!!window.measmerizeBrandIdWeb);
    const measmerizeSuggestedSize = useRef();
    const measmerizeSelectedSize = useRef();
    const measmerizeReady = useRef(false);
    const waitingForMeasmerize = useRef();
    const prevoiusPid = useRef();
    const createScriptWrap = () => {
        const scriptWrap = document.createElement('div');
        scriptWrap.setAttribute('id', scriptWrapId);
        document.body.appendChild(scriptWrap);
        return scriptWrap;
    };
    const embedMeasmerize = (pid) => {
        if (pid) {
            let script = document.createElement('script');
            const scriptID = 'measmerize-script';
            const scriptWrap = document.getElementById(scriptWrapId) || createScriptWrap();
            const previousScript = !!document.getElementById(scriptID);
            // previousScript && cleanScriptWrap(); // Clean up previous embed
            if (props.pid && measmerizeavailable) {
                if (previousScript) {
                    if (window.measmerize && window.measmerize.script) {
                        window.measmerize.script.productCode = props.pid;
                        //@ts-ignore
                        script = document.getElementById(scriptID);
                    }
                    else {
                        setMeasmerizeavailable(false);
                    }
                }
                else {
                    script.id = scriptID;
                    script.src = `https://${measmerizeconfig.url}/script.js`;
                    script.async = true;
                    // script.setAttribute('data-profile', 'low');
                    script.setAttribute('data-brand-code', window.measmerizeBrandIdWeb);
                    script.setAttribute('data-product-code', props.pid);
                    script.setAttribute('data-lang-code', window.language);
                    script.setAttribute('data-country-code', window.country);
                    scriptWrap === null || scriptWrap === void 0 ? void 0 : scriptWrap.appendChild(script);
                }
                script.addEventListener('measmerize.widget.ready', onMeasmerizeReady);
                script.addEventListener('measmerize.widget.unavailable', onMeasmerizeUnavailable);
                script.addEventListener('measmerize.widget.recommend', onMeasmerizeRecommend);
                script.addEventListener('measmerize.widget.select', onMeasmerizeSelect);
                script.addEventListener('measmerize.modal.close', onMeasmerizeClose);
            }
        }
    };
    const removeMeasmerizeListeners = () => {
        const script = document.getElementById('measmerize-script');
        if (script) {
            script.removeEventListener('measmerize.widget.ready', onMeasmerizeReady);
            script.removeEventListener('measmerize.widget.unavailable', onMeasmerizeUnavailable);
            script.removeEventListener('measmerize.widget.recommend', onMeasmerizeRecommend);
            script.removeEventListener('measmerize.widget.select', onMeasmerizeSelect);
            script.removeEventListener('measmerize.modal.close', onMeasmerizeClose);
        }
        // measmerizeReady.current = false;
        // cleanScriptWrap();
        props.onSizeSuggestion && props.onSizeSuggestion('');
    };
    // reload measmerize embed script
    useEffect(() => {
        if (props.pid != prevoiusPid.current) {
            prevoiusPid.current = props.pid;
        }
        else if (props.master != prevoiusPid.current) {
            prevoiusPid.current = props.master;
        }
        embedMeasmerize(prevoiusPid.current);
        return () => {
            removeMeasmerizeListeners();
        };
    }, [props.pid, measmerizeavailable]);
    const firstRender = useRef('');
    useEffect(() => {
        if (props.open && firstRender.current != props.pid) {
            firstRender.current = props.pid;
            if (props.sizeChart) {
                setSizeChart(props.sizeChart);
            }
            else {
                api.getSizeChart(props.pid).then((data) => setSizeChart(data));
            }
        }
    }, [props.pid, props.open, props.sizeChart]);
    useEffect(() => {
        props.open ? document.documentElement.classList.add('sizeguide-enabled') : document.documentElement.classList.remove('sizeguide-enabled');
        return () => {
            document.documentElement.classList.remove('sizeguide-enabled');
        };
    }, [props.open]);
    useEffect(() => {
        window.gbotNormalizer();
    }, [sizeChart]);
    const onMeasmerizeUnavailable = () => {
        setMeasmerizeavailable(false);
    };
    const onMeasmerizeSelect = (event) => {
        var _a;
        measmerizeSelectedSize.current = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.size;
    };
    useEffect(() => {
        // -- prevent auto zoom on select a input on mobile
        if (props.open) {
            const meta = document.createElement('meta');
            meta.name = 'viewport';
            meta.content = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0';
            document.getElementsByTagName('head')[0].appendChild(meta);
        }
        return () => {
            const meta = document.querySelector('meta[name=viewport]');
            meta === null || meta === void 0 ? void 0 : meta.remove();
        };
    }, [props.open]);
    const toggleMeasmerizeAnalytics = () => {
        let thirdParyAccepted = false;
        if (window.cookiePolicy === 'OneTrust' && cookie.load('OptanonAlertBoxClosed')) {
            // OneTrust
            const oneTrustChoices = cookie.load('OneTrustChoices');
            thirdParyAccepted = oneTrustChoices && oneTrustChoices.meTracking;
        }
        else if (cookie.load('TC_PRIVACY_CENTER')) {
            //Legacy Cookie System
            thirdParyAccepted = cookie.load('TC_PRIVACY_CENTER').includes('2');
        }
        if (thirdParyAccepted) {
            window.measmerize.tracking.enableAnalytics();
        }
        else {
            window.measmerize.tracking.disableAnalytics();
        }
    };
    const onMeasmerizeReady = (ev) => {
        measmerizeReady.current = true;
        toggleMeasmerizeAnalytics();
        customEventBus.on('cookieConsent:clicked', toggleMeasmerizeAnalytics);
        window.addEventListener('OneTrust:changed', toggleMeasmerizeAnalytics);
        if (waitingForMeasmerize.current) {
            window.measmerize.modal.mount();
            waitingForMeasmerize.current = false;
        }
        return true;
    };
    const onMeasmerizeClose = () => {
        var _a, _b;
        const size = measmerizeSelectedSize.current || measmerizeSuggestedSize.current;
        props.onSizeguideSelection && props.onSizeguideSelection(size);
        props.setSizeguideOpen(false);
        (_b = (_a = window.measmerize) === null || _a === void 0 ? void 0 : _a.modal) === null || _b === void 0 ? void 0 : _b.unMount();
    };
    const onMeasmerizeRecommend = (event) => {
        var _a;
        measmerizeSuggestedSize.current = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.size;
        props.onSizeSuggestion && props.onSizeSuggestion(measmerizeSuggestedSize.current);
    };
    const mountMeasmerizeWhenAvailable = () => {
        if (measmerizeReady.current) {
            window.measmerize.modal.mount();
        }
        else {
            waitingForMeasmerize.current = true;
            setMeasmerizeavailable(false);
        }
    };
    const onSizeGuideOpen = () => {
        mountMeasmerizeWhenAvailable();
        props.setSizeguideOpen && props.setSizeguideOpen(true);
    };
    const tabsLayout = () => (React.createElement(Tabs, { className: "tabs sizechart-tabs", forceRenderTabPanel: true },
        React.createElement("div", { className: "wrapper-tab-list" },
            React.createElement(TabList, { className: "react-tabs__tab-list" },
                measmerizeavailable && window.measmerize && (React.createElement(Tab, { onClick: () => {
                        analytics.sizeGuideOverlay(props.pid, 'find my size');
                    } }, t('sizeguide.findmysize'))),
                React.createElement(Tab, { onClick: () => analytics.sizeGuideOverlay(props.pid, 'body measurements') }, (props === null || props === void 0 ? void 0 : props.hideBodyMeasurements) ? t('sizeguide.itemmeasurements') : t('sizeguide.bodymeasurements')),
                sizeChart.mannequinGender && (sizeChart === null || sizeChart === void 0 ? void 0 : sizeChart.mannequinGender) != 'none' && (React.createElement(Tab, { onClick: () => analytics.sizeGuideOverlay(props.pid, 'how to measure') }, t('sizeguide.howtomeasure.title'))))),
        React.createElement("div", { className: "wrapper-tab-panels" },
            measmerizeavailable && window.measmerize && (React.createElement(TabPanel, null,
                React.createElement("div", { id: "measmerize-modal" }, window.loaderSrc && (React.createElement("div", { id: "loaderContainer" },
                    React.createElement("img", { src: window.loaderSrc, alt: "loader" })))))),
            React.createElement(TabPanel, null,
                React.createElement("div", { className: "product-details container" },
                    React.createElement(BodyMeasurements, { sizeChart: sizeChart }))),
            sizeChart.mannequinGender && (sizeChart === null || sizeChart === void 0 ? void 0 : sizeChart.mannequinGender) != 'none' && (React.createElement(TabPanel, null,
                React.createElement("div", { className: "product-details container" },
                    React.createElement(HowToMeasure, { contactformurl: props === null || props === void 0 ? void 0 : props.contactformurl, mannequinGender: sizeChart.mannequinGender.toLocaleLowerCase() })))))));
    return (React.createElement(React.Fragment, null,
        !(props === null || props === void 0 ? void 0 : props.onlyModal) && React.createElement(SizeGuideButton, { pid: props.pid, setSizeguideOpen: onSizeGuideOpen, withAria: true }),
        sizeChart && (React.createElement(React.Fragment, null,
            React.createElement(Drawers, { isOpen: props.open, onAfterOpen: () => {
                    if (props.onlyModal) {
                        mountMeasmerizeWhenAvailable();
                    }
                }, onRequestClose: () => {
                    analytics.sizeGuideOverlay(props.pid, 'close');
                    props.setSizeguideOpen(false);
                    onMeasmerizeClose();
                }, className: "measmerize-drawer" },
                React.createElement("div", { className: "product-details-tab drawer-details-composition" },
                    React.createElement("div", { className: "wrapper-product-details" }, tabsLayout()))),
            React.createElement("div", { className: "googlebot-content-view", hidden: true }, tabsLayout())))));
};
export default SizeGuide;
